import React from "react";
import { FaSpinner } from "react-icons/fa";

const PromoteConfirmModal = ({ isOpen, onClose, onConfirm, user, isLoading }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg shadow-lg p-6 max-w-sm w-full">
        <h2 className="text-lg font-semibold mb-4">Promote to Agent?</h2>
        <p className="text-sm mb-6">
          Are you sure you want to promote <strong>{user?.name}</strong> (
          {user?.email}) to an <strong>Agent</strong>?
        </p>
        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-600 border border-gray-300 rounded hover:text-gray-800"
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            onClick={() => onConfirm(user)}
            disabled={isLoading}
            className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700 flex items-center gap-2 disabled:opacity-60"
          >
            {isLoading && (
              <FaSpinner className="animate-spin" size={16} />
            )}
            {isLoading ? "Promoting..." : "Yes, Promote"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PromoteConfirmModal;
